import type { Address } from "@src/library/types/events";

export const parseAddress = (address: Address) => {
    const parts = [];
    if (address?.city) parts.push(`г. ${address.city}`);
    if (address?.street) parts.push(`улица ${address.street}`);
    if (address?.house) parts.push(`дом ${address.house}`);
    if (address?.unit) parts.push(`корпус ${address.unit}`);
    if (address?.office) parts.push(`квартира ${address.office}`);
    return parts.join(', ');
}